/**
 * File view.js.
 *
 * Handles Resources Center block.
 */
(function ($) {
	'use strict';

	// Resource data filter by product hashtag on page load.
	let hashKeyProduct = $( location ).prop( 'hash' ) || '';
		hashKeyProduct = hashKeyProduct.replace( '#', '' );
	if ( '' != hashKeyProduct && undefined != hashKeyProduct ) {
		resourceDataByProductHashtag( hashKeyProduct );
	}

	// Clear all filters
	$( document ).on( 'click', '.resource-center__head-filters-clear a', function (e) {
		let parentObj = $( this ).parents( '.resource-center' );
		parentObj.find( '.resource-center__head-industry-filter' ).val( '' );
		parentObj.find( '.resource-center__head-document-type-filter' ).val( '' );
		parentObj.find( '.resource-center__head-product-filter' ).val( '' );
		window.location.hash = 'all';
		productDataAjax( parentObj, '', '' );
		resourcesDataAjax( parentObj, '', '', '' );
	});

	// Change event of industry
	$( document ).on( 'change', '.resource-center__head-industry-filter', function (e) {
		let parentObj    = $( this ).parents( '.resource-center' );
		let industry     = $( this ).val();
		let resourceType = parentObj.find( '.resource-center__head-document-type-filter' ).val() || '';
		let productKey   = parentObj.find( '.resource-center__head-product-filter' ).val() || '';
		let product      = parentObj.find( '.resource-center__head-product-filter option[value="' + productKey + '"]' ).attr( 'data-id' ) || '';
		productDataAjax( parentObj, industry, product );
		resourcesDataAjax( parentObj, industry, product, resourceType );
	});

	// Change event of resource type
	$( document ).on( 'change', '.resource-center__head-document-type-filter', function (e) {
		let parentObj    = $( this ).parents( '.resource-center' );
		let industry     = parentObj.find( '.resource-center__head-industry-filter' ).val() || '';
		let resourceType = $( this ).val();
		let productKey   = parentObj.find( '.resource-center__head-product-filter' ).val() || '';
		let product      = parentObj.find( '.resource-center__head-product-filter option[value="' + productKey + '"]' ).attr( 'data-id' ) || '';
		resourcesDataAjax( parentObj, industry, product, resourceType );
	});

	// Change event of product
	$( document ).on( 'change', '.resource-center__head-product-filter', function (e) {
		let parentObj    = $( this ).parents( '.resource-center' );
		let industry     = parentObj.find( '.resource-center__head-industry-filter' ).val() || '';
		let resourceType = parentObj.find( '.resource-center__head-document-type-filter' ).val() || '';
		let productKey   = $( this ).val();
		let product      = parentObj.find( '.resource-center__head-product-filter option[value="' + productKey + '"]' ).attr( 'data-id' ) || '';
		window.location.hash = productKey;
		resourcesDataAjax( parentObj, industry, product, resourceType );
	});

	// Load more resources.
	$( document ).on( 'click', '.resources-load-more-btn', function(){
		let parentObj    = $( this ).parents( '.resource-center' );
		let industry     = parentObj.find( '.resource-center__head-industry-filter' ).val() || '';
		let resourceType = parentObj.find( '.resource-center__head-document-type-filter' ).val() || '';
		let productKey   = parentObj.find( '.resource-center__head-product-filter' ).val() || '';
		let product      = parentObj.find( '.resource-center__head-product-filter option[value="' + productKey + '"]' ).attr( 'data-id' ) || '';
		let paged        = $( this ).attr( 'data-page' ) ? parseInt( $( this ).attr( 'data-page' ) ) + 1 : 1;
		resourcesDataAjax( parentObj, industry, product, resourceType, paged, true );
	});

    // Resource data filter by product.
	function resourceDataByProductHashtag( productKey ) {
		let parentObj    = $( '.resource-center' );
		let industry     = parentObj.find( '.resource-center__head-industry-filter' ).val() || '';
		let resourceType = parentObj.find( '.resource-center__head-document-type-filter' ).val() || '';
		let product      = parentObj.find( '.resource-center__head-product-filter option[value="' + productKey + '"]' ).attr( 'data-id' ) || '';
		parentObj.find( '.resource-center__head-product-filter' ).val( productKey );
		resourcesDataAjax( parentObj, industry, product, resourceType );
	}

	// Ajax for Product List
	function productDataAjax( parentObj, industry, product ) {
		parentObj.addClass('resource-center-loading');
        jQuery.ajax({
            type: 'POST',
            dataType: "json",
            data: {
                action: "get_product_data",
                ajax_nonce: siteConfig.ajax_nonce,
                industry: industry,
				product: product,
            },
            url: siteConfig.ajaxUrl,
            success: function ( postData ) {
                let postObj          = postData.data.result_post;
				let productFilterObj = parentObj.find( '.resource-center__head-product-filter' );
				productFilterObj.html( postObj );
				parentObj.removeClass('resource-center-loading');
            }
        });
	}

    // Ajax for Resources List
    function resourcesDataAjax( parentObj, industry, product, resourceType, paged = 1, loadMore = false ) {
        let postPerPage             = parentObj.attr( 'data-post-per-page' );
        let resourcesCenterSettings = parentObj.attr( 'data-settings' );
		parentObj.addClass('resource-center-loading');
        jQuery.ajax({
            type: 'POST',
            dataType: "json",
            data: {
                action: "resources_center_filter",
                ajax_nonce: siteConfig.ajax_nonce,
                post_per_page: postPerPage,
                industry: industry,
                resource_type: resourceType,
                product: product,
                resources_center_settings: resourcesCenterSettings,
                paged: paged,
				load_more: loadMore ? 1 : 0,
            },
            url: siteConfig.ajaxUrl,
            success: function ( postData ) {
                let postObj         = postData.data.result_post;
				let totalPosts      = postData.data.total_posts;
                let maxPages        = postData.data.max_pages;
                let innerSectionObj = parentObj.find( '.resource-center__inner' );
				let resultsCountObj = parentObj.find( '.resource-center__head-filters-results span' );

                if ( loadMore ) {
					innerSectionObj.find( '.resource-center__inner-section:last-child .resource-center__inner-boxes' ).append( postObj );
					let loadMoreObj = parentObj.find( '.resources-load-more-btn' );
					loadMoreObj.attr( 'data-page', paged );
					if (maxPages > paged) {
						loadMoreObj.show();
					} else {
						loadMoreObj.hide();
					}
                } else {
					innerSectionObj.html( postObj );
					resultsCountObj.text( totalPosts );
				}
				// parentObj[0].scrollIntoView({ behavior: 'smooth' });
				parentObj.removeClass('resource-center-loading');
            }
        });
    }
})( jQuery );
